/**
 * Copyright © 2026 Adnuntius AS.
 */
import JSZip from 'jszip';

export interface ZippedHtmlFile {
  name: string;
  contents: string;
}

export async function addIndividuallyZippedHtmlFiles(
  archive: JSZip,
  files: ZippedHtmlFile[]
): Promise<void> {
  await Promise.all(files.map(async (file) => {
    const individualArchive = new JSZip();
    individualArchive.file(file.name + '.html', file.contents);
    const contents = await individualArchive.generateAsync({type: 'uint8array'});
    archive.file(file.name + '.zip', contents);
  }));
}
